import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const Paperclip = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15.303 6.6 7.73 14.326a1.8 1.8 0 1 0 2.546 2.546l7.573-7.728a3.6 3.6 0 1 0-5.091-5.09L5.216 11.75a5.401 5.401 0 1 0 7.637 7.637l7.541-7.696"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(Paperclip) as SvgIcon;
export { ForwardRef as ReactComponent };
